export default __webpack_public_path__ + "static/media/elmorro.214bca30.jpeg";